export class RequestFilterForm {
  companyCode?: string;
  placeId?: number;
  active?: boolean;

  pageSize = 10;
  pageOffset = 0;
}
